import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiProjectedFinancialPerformance from '../../Api/ApiProjectedFinancialPerformance';
import ToastMsg from '../../Components/ToastMsg';
import { creators as ProjectedFinancialPerformanceActions } from '../../Reducers/Reporting/ProjectedFinancialPerformance';

export function* getProjectedFinancialPerformanceSummary({ payload }) {
  try {
    const response = yield call(
      ApiProjectedFinancialPerformance.getSummary,
      payload.selectedYears,
      payload.dimDateKeys,
    );

    if (response.status === 200) {
      yield put(
        ProjectedFinancialPerformanceActions.prjfinancialperfSuccess({
          summaryData: response.data,
        }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Projected Financial Performance Summary',
            text: response.message,
          },
        },
      );
      yield put(ProjectedFinancialPerformanceActions.prjfinancialperfFailure(response.message));
    }
  } catch (e) {
    yield put(ProjectedFinancialPerformanceActions.prjfinancialperfFailure(e));
  }
}

export function* getProjectedFinancialPerformanceDetail({ payload, defaultDimDate }) {
  try {
    const response = yield call(
      ApiProjectedFinancialPerformance.getDetail,
      payload.dimDateKeys,
      payload.defaultDimDate
    );

    if (response.status === 200) {
      yield put(
        ProjectedFinancialPerformanceActions.prjfinancialperfSuccess({
          detailData: response.data,
        }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Projected Financial Performance Detail',
            text: response.message,
          },
        },
      );
      yield put(ProjectedFinancialPerformanceActions.prjfinancialperfFailure(response.message));
    }
  } catch (e) {
    yield put(ProjectedFinancialPerformanceActions.prjfinancialperfFailure(e));
  }
}
